export default __webpack_public_path__ + "static/phone-frame@2x-55b154c7bc70626f19ae7639c74544d6.png";